// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2dR05","inputs":"styles_inputs__2uSew","checkboxes":"styles_checkboxes__2ib_t"};